import "react-image-crop/dist/ReactCrop.css";
import CreateEditionForm from "./form";

const CreateEdition = () => {
  return <CreateEditionForm />;
};

export default CreateEdition;
